var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('CookieChoice'),_c('Header',{attrs:{"msg":"Header"}}),_c('VideoDemo',{attrs:{"msg":"VideoDemo"}}),_c('Footer',{attrs:{"msg":"Footer"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }